import { gql } from '@apollo/client';


export const REMOVE_AXLE_FROM_AXLE_GROUP = gql`
mutation removeAxleFromAxleGroup($input: RemoveAxleFromAxleGroupInput!) {
  removeAxleFromAxleGroup(input: $input) {
    clientMutationId
    errors
    
  }
}
`